export const insiderLocalEvents = (deliveryType: DeliveryType, localId: string, city: string) => {
    window.InsiderQueue = [];
    window.InsiderQueue.push({
        type: 'custom_event',
        value: [
            {
                event_name:
                    deliveryType === 1
                        ? 'choose_order_with_delivery'
                        : 'choose_order_pickup'
            }
        ]
    });
    window.InsiderQueue.push({
        type: 'custom_event',
        value: [
            {
                event_name: 'add_delivery_address',
                event_parameters: {
                    custom: {
                        store: localId,
                        city
                    }
                }
            }
        ]
    });
    window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
};
